import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { AiConnector } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AiConnectorService {
  subbotBaseUrl = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${this.alcmeonContextService.siteId}/subbot`;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  getAiConnectorDescription(): Observable<AiConnector> {
    return this.http
      .get<AiConnector>(`${this.subbotBaseUrl}/ai-connector/description`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getAiConnectorSelectParams(param: string): Observable<any> {
    return this.http
      .get<any>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/subbot/select-param`, {
        params: { param_name: param },
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
